/** Checklist items of todo content (or its card), shared by the frame and its card preview. */

export interface TodoItem {
  id: string;
  text: string;
  detail?: string;
  done?: boolean;
}

function toTodoItem(raw: unknown, index: number): TodoItem | null {
  if (typeof raw !== "object" || raw === null) return null;
  const m = raw as Record<string, unknown>;
  if (typeof m.text !== "string") return null;
  return {
    id: typeof m.id === "string" ? m.id : `item-${index}`,
    text: m.text,
    detail: typeof m.detail === "string" ? m.detail : undefined,
    done: m.done === true,
  };
}

/** The valid items of `content.items`; anything else is dropped. */
export function todoItemsFrom(items: unknown): TodoItem[] {
  if (!Array.isArray(items)) return [];
  return items
    .map((raw, index) => toTodoItem(raw, index))
    .filter((item): item is TodoItem => item !== null);
}

/**
 * The object items of `content.items` as saved, each with the id its row
 * shows (`todoItemsFrom` falls back to the index too), so an edit addresses
 * the row the user touched even before the backend has given it an id.
 */
export function savedItemsWithIds(items: unknown): Record<string, unknown>[] {
  if (!Array.isArray(items)) return [];
  return items.flatMap((raw, index) => {
    if (typeof raw !== "object" || raw === null) return [];
    const item = raw as Record<string, unknown>;
    return [
      { ...item, id: typeof item.id === "string" ? item.id : `item-${index}` },
    ];
  });
}
